import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employment Type',
  'Gender',
  'Last Day of Benefits',
  'Last Day of Work',
  'Location',
  'Manager',
  'Start Date',
  'Terminated Employee',
  'Termination Type'
];

const TerminatedEmployeesReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report name={t('reports.TERMINATED_EMPLOYEES_REPORT')}
              url='/reports/terminated_employees'>
      </Report>
    </CompositeReport>
  );
};

export default TerminatedEmployeesReport;
